<template lang="pug">
  .period-tabs__item(
    :class="classes"
    :style="styles"
    @click="selectTab")
    .period-tabs__item-title
      i.i-util-bars.loading-item-handle
      span {{ title }}

    v-btn(
      v-if="isSelected && !item.deleted"
      :disabled="!hasPermission('loading', 'change')"
      icon
      :loading="loading"
      @click="onClick")
      v-icon(
        icon="cog"
        font-size="1.1")

    v-dialog(
      max-width="335"
      v-model="modals.showSettingsPeriod")
      settings-period-modal(
        :id="item.id"
        :status="status"
        :period="period"
        @update="update"
        @close="modals.showSettingsPeriod = false")
</template>

<script>
import api from '@/api'

import { getFarmPath } from '@/util/app.js'
import adaptationMixin from '@/mixins/adaptation.mixin.js'

import SettingsPeriodModal from './modals/SettingsPeriodModal'

export default {
  name: 'EditableTab',

  mixins: [adaptationMixin],

  components: {
    SettingsPeriodModal
  },

  props: {
    item: Object,
    count: Number
  },

  data: () => ({
    modals: {
      showSettingsPeriod: false
    },
    loading: false,
    status: false,
    period: null
  }),

  methods: {
    selectTab () {
      this.$router.push(this.path)
    },

    update () {
      this.$emit('update')
    },

    openEditDialog () {
      let path = this.$route.path
      this.$router.push(path + this.item.id + '/loading/edit')
    },

    async onClick () {
      this.loading = true
      await this.loadData()
      await this.loadStatus()
      this.loading = false
      this.modals.showSettingsPeriod = true
    },

    async loadData () {
      const id = this.$route.query.loading
      const { data } = await api.loadings.getById(id)
      this.period = data
    },

    async loadStatus () {
      const { id } = this.item
      const { data } = await api.schedule.loadings.getById(id)
      this.status = data.is_active
    }
  },

  computed: {
    classes () {
      return {
        'period-tabs__item--selected': this.isSelected,
        'period-tabs__item--deleted': this.item.deleted
      }
    },

    styles () {
      return {
        width: this.count > 1
          ? `calc(${100 / this.count}% - 0.8rem)`
          : '100%'
      }
    },

    isSelected () {
      return +this.$route.query.loading === this.item.loading
    },

    title () {
      return !this.isMobile
        ? this.item.name.length > 16
          ? (this.item.name.substring(0, 11) + '...')
          : this.item.name
        : this.item.name.length > 40
          ? (this.item.name.substring(0, 40) + '...')
          : this.item.name
    },

    path () {
      const date = this.$route.query.date
      return getFarmPath(null, this.$route, `?loading=${this.item.loading}&date=${date}`)
    },

    allowChange () {
      return this.hasPermission('schedule_loading', 'change')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/abstracts/_mixins.scss';

.loading-item-handle {
  cursor: move;
}

.period-tabs__item {
  cursor: pointer;
  height: 4rem;
  display: flex;
  font-size: 1.7rem;
  align-items: center;
  justify-content: space-between;
  background-color: #D0D0D0;
  padding: 0 .5rem 0 1.2rem;
  border-radius: 1rem;
  transition: .3s linear;

&-title {
  display: flex;
  align-items: center;

    @include mobile {
      font-weight: 600;
    }

    i {
      margin-right: 1.5rem;

      @include mobile {
        display: none;
      }
    }
  }

  &:hover {
    background-color: #dfdfdf;
  }

  &--selected {
    background-color: #F9CD13 !important;
  }

  &--deleted {
    background-color: #e72e2e !important;
  }
}
</style>
